@let message = currentErrorMessage();
@if (message.active) {
  <main [class.opacity-0]="message.hide" [class.opacity-100]="!message.hide"
        [class.open]="!message.hide"
        class="transition-opacity duration-700 fixed top-0 left-0 z-50 flex flex-col w-screen h-full m-auto backdrop-grayscale backdrop-blur-sm fadeInOnEnterQuickly">

    <section class="z-50 flex flex-col fixed bg-white dark:bg-black h-screen w-full mx-auto max-w-screen-xl xs:p-2 xs:h-auto xs:shadow-2xl xs:rounded-xl xs:top-1/10 xs:left-1/10 xs:w-8/10 xs:bottom-1/10 sm:left-2/10 sm:w-6/10 xl:left-3/10 xl:w-4/10 xl:bottom-2/10">
      <div class="p-4 mt-2 overflow-y-scroll overscroll-contain">
        <div class="h5 font-semibold leading-tight" [innerHTML]="message.errorObject.title"></div>

        @if (message.errorObject.body) {
          <div class="mt-4 text-[15px]" [innerHTML]="message.errorObject.body"></div>
        }

        @for (errorLine of message.errorObject.errorLines; track errorLine.title) {
          <InfoCard
              [titleKey]="errorLine.title"
              [bodyKey]="errorLine.body"></InfoCard>
        }
      </div>

      <!--button
          class="absolute bg-transparent text-4xl leading-none right-0 top-0 py-2 px-3 outline-none focus:outline-none hidden md:block"
          (click)="hideMessage()">
        <span [style.color]="appColor ? appColor : '#FF8000'">×</span>
      </button-->

      @if (message.errorObject.buttonAction) {
        <footer class="flex flex-col flex-grow justify-end mb-2 mx-4">
          <div class="flex justify-end">
            <BizcuitButton
                [outline]="false"
                [disabled]="processing()"
                color="#E90038"
                (click)="buttonClicked()">
              {{ message.errorObject.buttonText }}
            </BizcuitButton>
          </div>
          @if (message.errorObject.secondaryButtonAction) {
            <div class="flex justify-end">
              <BizcuitButton
                  [outline]="false"
                  [disabled]="processing()"
                  [color]="appColor ? appColor : '#FF8000'"
                  (click)="secondaryButtonClicked()">
                {{ message.errorObject.secondaryButtonText }}
              </BizcuitButton>
            </div>
          }
        </footer>
      }
    </section>
  </main>
}
